import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/feeInvoiceType/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/feeInvoiceType/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/remove', qs.stringify(params),options);

export const add = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/submit', params,options);

export const update = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/submit', params,options);
export const selectInterface = (params, options) =>
  request.get('/api/v4ward/feeInvoiceInterface/selectFeeInvoceInterfacList',  Object.assign({}, options, { params }));

export const getInvoiceTypeList = (params, options) =>
  request.get('/api/v4ward/feeInvoiceType/selectFeeInvoiceTypeList',  Object.assign({}, options, { params }));

//登录-第一步
export const loginFirst = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/login-first', params,options);

//登录-第二步
export const loginSecond = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/login-second', params,options);

//确认蓝票二维码认证
export const confirmBlueAuth = (params, options) =>
  request.post('/api/v4ward/feeInvoiceType/confirm-auth', params,options);
